import { PlusOutlined } from "@ant-design/icons";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
  DownloadV2,
} from "@components";

import { PATH_CLIENT_CREATE, clientFilter, enumJoinedProgram } from "@configs";
import { ClientTable } from "@modules";
import { selectApp } from "@redux";
import { getApiErrorMessage, useClientListPage, useExportClientRecords, useNotify } from "@utils";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

export const PageListClients = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  const exportRecords = useExportClientRecords();

  const {
    data,
    total,
    page,
    filters,
    date,
    refetch,
    handlePagination,
    changeFilter,
    searchText,
    handleClearSearch,
  } = useClientListPage(enumJoinedProgram.MNCH);

  const goToCreate = () => history.push(PATH_CLIENT_CREATE);

  const handleDownloadCsv = async () => {
    try {
      const { data: fileData } = await exportRecords.mutateAsync({
        variant: "standard",
        params: {
          searchColumn: "program",
          search: "MNCH",
          startDate: date[0],
          endDate: date[1],
        },
      });
      const url = window.URL.createObjectURL(new Blob([fileData], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Exported MNCH client records.csv");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err) {
      error(getApiErrorMessage(err, t("message.download.fail")));
    }
  };

  const button = (
    <>
      <Tooltip title={t("page.download_mnch_client_excel")}>
        <SharedButton
          type="primary"
          icon={<DownloadV2 />}
          size="middle"
          onClick={handleDownloadCsv}
          style={{ background: "#00AA67", color: "#fff" }}
        >
          {t("page.download")}
        </SharedButton>
      </Tooltip>
      <Tooltip title={t("page.add_client")}>
        {mobile ? (
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        ) : (
          <SharedButton
            type="primary"
            ghost
            icon={<PlusOutlined />}
            size="middle"
            onClick={goToCreate}
          >
            {t("page.add_client")}
          </SharedButton>
        )}
      </Tooltip>
    </>
  );

  return (
    <>
      <ComponentHeader title={t("page.client_information")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={clientFilter}
            callbackFun={changeFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.client_search_placeholder")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <ClientTable data={data} callback={refetch} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
